// 全站共享文案（导航/页脚/通用）：zh 为完整基准，en 逐 key 对齐
export interface CommonDict {
    nav: {
        library: string
        cooperate: string
        cases: string
        developers: string
        app: string
        contact: string
    }
    libraryMenu: {
        featured: string
        featuredDesc: string
        solutions: string
        solutionsDesc: string
    }
    appDropdown: {
        title: string
    }
    game: {
        // 横竖版徽标映射：key 为数据库存储值
        screen: Record<string, string>
        viewDetail: string
    }
    footer: {
        slogan: string
        stats: {
            // 数字后缀单位（如「款」），en 为空串
            games: { label: string; suffix: string }
            categories: { label: string; suffix: string }
            // 语种与服务为固定承诺文案，不读库
            languages: { label: string; value: string }
            service: { label: string; value: string }
        }
        linkGroups: { title: string; links: { label: string; href: string }[] }[]
        phoneLabel: string
        emailLabel: string
        qrWechatLabel: string
    }
}

export const commonDict: { zh: CommonDict; en: CommonDict } = {
    zh: {
        nav: {
            library: '内容为王',
            cooperate: '合作方式',
            cases: '客户案例',
            developers: '开发者',
            app: '体验APP',
            contact: '联系我们',
        },
        libraryMenu: {
            featured: '推荐游戏',
            featuredDesc: '精选热门玩法，快速引流',
            solutions: '运营方案',
            solutionsDesc: '丰富运营玩法，助力营收增长',
        },
        appDropdown: {
            title: 'Demo扫码体验',
        },
        game: {
            screen: { 竖版: '竖版', 横版: '横版', 横竖版: '横竖版' },
            viewDetail: '查看详情',
        },
        footer: {
            slogan: '游戏化互动时代，互动游戏为创新加速',
            stats: {
                games: { label: '服务内容', suffix: '款' },
                categories: { label: '内容分类', suffix: '类' },
                languages: { label: '支持语种', value: '中 / 英' },
                service: { label: '服务保障', value: '7×24' },
            },
            linkGroups: [
                {
                    title: '内容',
                    links: [
                        { label: '内容为王', href: '/gamelist2' },
                        { label: '推荐游戏', href: '/gamelist2?tab=recommended' },
                        { label: '运营方案', href: '/solutions' },
                    ],
                },
                {
                    title: '合作',
                    links: [
                        { label: '合作方式', href: '/cooperate2' },
                        { label: '客户案例', href: '/cases' },
                        { label: '开发者', href: '/developers' },
                    ],
                },
                {
                    title: '支持',
                    links: [
                        { label: '联系我们', href: '/contact2' },
                        { label: '用户协议', href: '/agreement' },
                        { label: '隐私政策', href: '/privacy' },
                    ],
                },
            ],
            phoneLabel: '电话',
            emailLabel: '邮箱',
            qrWechatLabel: '商务微信',
        },
    },
    en: {
        nav: {
            library: 'Content is King',
            cooperate: 'Cooperation',
            cases: 'Cases',
            developers: 'Developers',
            app: 'Demo App',
            contact: 'Contact Us',
        },
        libraryMenu: {
            featured: 'Featured Games',
            featuredDesc: 'Top picks to boost your traffic',
            solutions: 'Operation Solutions',
            solutionsDesc: 'Rich operation innovations for growth',
        },
        appDropdown: {
            title: 'Scan to Try the Demo',
        },
        game: {
            screen: { 竖版: 'Portrait', 横版: 'Landscape', 横竖版: 'Universal' },
            viewDetail: 'Learn More',
        },
        footer: {
            slogan: 'In the era of gamified interaction, interactive games accelerate innovation',
            stats: {
                games: { label: 'Games', suffix: '' },
                categories: { label: 'Categories', suffix: '' },
                languages: { label: 'Languages', value: 'ZH / EN' },
                service: { label: 'Support', value: '7×24' },
            },
            linkGroups: [
                {
                    title: 'Content',
                    links: [
                        { label: 'Content is King', href: '/gamelist2' },
                        { label: 'Featured Games', href: '/gamelist2?tab=recommended' },
                        { label: 'Operation Solutions', href: '/solutions' },
                    ],
                },
                {
                    title: 'Cooperation',
                    links: [
                        { label: 'Cooperation', href: '/cooperate2' },
                        { label: 'Cases', href: '/cases' },
                        { label: 'Developers', href: '/developers' },
                    ],
                },
                {
                    title: 'Support',
                    links: [
                        { label: 'Contact Us', href: '/contact2' },
                        { label: 'User Agreement', href: '/agreement' },
                        { label: 'Privacy Policy', href: '/privacy' },
                    ],
                },
            ],
            phoneLabel: 'Phone',
            emailLabel: 'Email',
            qrWechatLabel: 'Business WeChat',
        },
    },
}
